<script>
  import ProfileSummary from './profile_summary.svelte'
  import MomentsSection from './moments_section.svelte'
  import QuestSubmissionsSection from './quest_submissions_section.svelte'
  import MediaUploadsSection from './media_uploads_section.svelte'
  import FriendshipsSection from './friendships_section.svelte'
  import BlocksSection from './blocks_section.svelte'
  import ReportsSection from './reports_section.svelte'

  let { social } = $props()
</script>

{#if social}
  <div class="space-y-6">
    <ProfileSummary profile={social.profile} />
    <MomentsSection moments={social.moments} />
    {#if social.quest_submissions}
      <QuestSubmissionsSection questSubmissions={social.quest_submissions} />
    {/if}
    {#if social.media_uploads}
      <MediaUploadsSection mediaUploads={social.media_uploads} />
    {/if}
    <FriendshipsSection friendships={social.friendships} />
    <BlocksSection given={social.blocks_given} received={social.blocks_received} />
    <ReportsSection received={social.reports_received} filed={social.reports_filed} />
  </div>
{/if}
